import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Minibar from '../../../components/navbar/Minibar';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';
import './cctv.css'

function CCTVStreaming(props) {
    const clientid = useRef(generateUUID())
    const queueRef = useRef([[], [], [], [], [], [], [], [], []]);
    const channelRef = useRef(['', '', '', '', '', '', '', '', '']);
    const packageRef = useRef([0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [channel_selected, setChannel_Selected] = useState(-1);

    const mediaSource = useRef([null, null, null, null, null, null, null, null, null]);
    const sourceBuffer = useRef([null, null, null, null, null, null, null, null, null])
    const videoRef = useRef([null, null, null, null, null, null, null, null, null])

    var cam_ws = useRef(null)
    var block_ws_req = useRef([false, false, false, false, false, false, false, false, false])
    var block_ws_state = useRef([false, false, false, false, false, false, false, false, false])

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    const [cam_list, setCamList] = useState([]);
    const temp_api_state = useRef(0)
    const [api_state, setAPIState] = useState(0);
    const [api_state_display, setAPIState_display] = useState(false);

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return async () => {
            if (cam_ws.current !== null) {
                console.log('unmount')
                cam_ws.current.onopen = null
                cam_ws.current.onclose = null
                cam_ws.current.onmessage = null
                if (cam_ws.current.readyState === WebSocket.OPEN) {
                    cam_ws.current.close()
                }
                cam_ws = null
            }
            await remove_mediasource(0)
            await remove_mediasource(1)
            await remove_mediasource(2)
            await remove_mediasource(3)
            await remove_mediasource(4)
            await remove_mediasource(5)
            await remove_mediasource(6)
            await remove_mediasource(7)
            await remove_mediasource(8)

            queueRef.current[0] = null
            queueRef.current[1] = null
            queueRef.current[2] = null
            queueRef.current[3] = null
            queueRef.current[4] = null
            queueRef.current[5] = null
            queueRef.current[6] = null
            queueRef.current[7] = null

            const formData = new FormData()
            formData.append('client_id', clientid.current)
            formData.append('command', "########")
            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/api/cctv/selectchannel", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {

                })
                .catch((err) => {

                });
        }
    }, []);

    useEffect(() => {
        if (api_state === 3) {
            // enable_mediasource(0)
            // enable_mediasource(1)
            // enable_mediasource(2)
            // enable_mediasource(3)
            // enable_mediasource(4)
            // enable_mediasource(5)
            // enable_mediasource(6)
            // enable_mediasource(7)
            api_socket_connect(channelRef.current.join("-"))
        }
    }, [api_state]);

    useEffect(() => {
        if (props.data_uioption.camera !== undefined) {
            setCamList(props.data_uioption.camera.camera_list)
        }
    }, [props.data_uioption]);

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    async function api_socket_connect(command) {
        return new Promise(async (resolve, reject) => {
            if (cam_ws.current !== null) {
                cam_ws.current.onopen = null
                cam_ws.current.onclose = null
                cam_ws.current.onmessage = null
                if (cam_ws.current.readyState === WebSocket.OPEN) {
                    cam_ws.current.close()
                }
                temp_api_state.current = 0
                setAPIState(temp_api_state.current)
                cam_ws.current = null
            }

            queueRef.current = [[], [], [], [], [], [], [], [], []]
            packageRef.current = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            cam_ws.current = new WebSocket(process.env.REACT_APP_API_URL + props.permitdata.proxy + `/api/cctv/streaming?clientid=` + clientid.current + `&&command=` + command);
            cam_ws.current.binaryType = 'arraybuffer';
            console.log('Camera Stream API Connecting')
            cam_ws.current.onopen = async () => {
                console.log('Camera Stream API Connected')
                temp_api_state.current = 2
                setAPIState(temp_api_state.current)
                resolve(true)
            };

            cam_ws.current.onmessage = async (event) => {
                temp_api_state.current = 2
                setAPIState(temp_api_state.current)
                setAPIState_display(false)
                const arrayU8x = new Uint8Array(event.data)
                const stream_channel = arrayU8x[arrayU8x.length - 3]
                const cam_no = arrayU8x[arrayU8x.length - 2]
                const protocol_type = arrayU8x[arrayU8x.length - 1]
                const arrayU8 = arrayU8x.slice(0, arrayU8x.length - 3)

                if (stream_channel >= 0 && stream_channel < 9 && cam_no > 0) {
                    if (mediaSource.current[stream_channel] !== null) {
                        if (mediaSource.current[stream_channel].readyState === 'open' && arrayU8.length > 12 && block_ws_req.current[stream_channel] === false) {
                            block_ws_state.current[stream_channel] = true
                            if (protocol_type === 0 || protocol_type === 1) {
                                const camkey = "Cam" + cam_no
                                if (camkey === channelRef.current[stream_channel]) {
                                    if (protocol_type === 0) {
                                        queueRef.current[stream_channel] = []
                                        packageRef.current[stream_channel] = 0
                                        if (sourceBuffer.current[stream_channel].updating || queueRef.current[stream_channel].length > 0) {
                                            queueRef.current[stream_channel].push(arrayU8);
                                            packageRef.current[stream_channel] += 1
                                        } else {
                                            sourceBuffer.current[stream_channel].appendBuffer(arrayU8);
                                            packageRef.current[stream_channel] += 1
                                        }
                                    } else if (protocol_type === 1) {
                                        if (packageRef.current[stream_channel] >= 1) {
                                            if (sourceBuffer.current[stream_channel].updating || queueRef.current[stream_channel].length > 0) {
                                                queueRef.current[stream_channel].push(arrayU8);
                                                packageRef.current[stream_channel] += 1
                                            } else {
                                                sourceBuffer.current[stream_channel].appendBuffer(arrayU8);
                                                packageRef.current[stream_channel] += 1
                                            }
                                        } else {
                                            packageRef.current[stream_channel] = 0
                                            queueRef.current[stream_channel] = []
                                        }
                                    }
                                } else {
                                    packageRef.current[stream_channel] = 0
                                    queueRef.current[stream_channel] = []
                                }
                            }
                            block_ws_state.current[stream_channel] = false
                        }
                    }
                } else {
                    if (stream_channel === 77 && cam_no === 88 && protocol_type === 99) {
                        const s = new TextDecoder().decode(arrayU8)
                        setCamList(JSON.parse(s))
                    }
                }
            };

            cam_ws.current.onclose = (event) => {
                const idx = channelRef.current.findIndex((element) => element.includes('Cam'))
                if (idx >= 0) {
                    console.log("Camera Stream API Connection Lose");
                    temp_api_state.current = 3
                    setAPIState_display(true)
                } else {
                    temp_api_state.current = 0
                    setAPIState_display(false)
                }
                setAPIState(temp_api_state.current)
                resolve(false)
            };
        })
    }


    function enable_mediasource(stream_channel) {
        return new Promise((resolve, reject) => {
            queueRef.current[stream_channel] = []
            packageRef.current[stream_channel] = 0

            if (mediaSource.current[stream_channel] !== null) {
                mediaSource.current[stream_channel].onsourceopen = null
                mediaSource.current[stream_channel] = null
            }
            if (sourceBuffer.current[stream_channel] !== null) {
                sourceBuffer.current[stream_channel].onupdateend = null
                sourceBuffer.current[stream_channel].onerror = null
                sourceBuffer.current[stream_channel] = null
            }

            mediaSource.current[stream_channel] = new MediaSource()
            const video = videoRef.current[stream_channel];
            video.src = URL.createObjectURL(mediaSource.current[stream_channel]);
            if (video !== null) {
                mediaSource.current[stream_channel].onsourceopen = (event) => {
                    sourceBuffer.current[stream_channel] = mediaSource.current[stream_channel].addSourceBuffer('video/mp4; codecs="avc1.4D0016"');
                    sourceBuffer.current[stream_channel].mode = 'segments';

                    sourceBuffer.current[stream_channel].onupdateend = async (event) => {
                        var timestamp_sec = (event.timeStamp / 1E3) | 0;
                        if (queueRef.current[stream_channel].length > 0 && !sourceBuffer.current[stream_channel].updating) {
                            sourceBuffer.current[stream_channel].appendBuffer(queueRef.current[stream_channel].shift());
                        }
                        if (!sourceBuffer.current[stream_channel].updating) {
                            const slen = sourceBuffer.current[stream_channel].buffered.length
                            if (slen >= 1) {
                                const diff = sourceBuffer.current[stream_channel].buffered.end(slen - 1) - sourceBuffer.current[stream_channel].buffered.start(slen - 1)
                                if (diff >= 20) {
                                    var remove_track = sourceBuffer.current[stream_channel].buffered.end(slen - 1) - 10
                                    sourceBuffer.current[stream_channel].remove(0, remove_track)
                                }
                            }
                        }
                        if (!sourceBuffer.current[stream_channel].updating) {
                            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended
                                && video.readyState > video.HAVE_CURRENT_DATA;
                            if (!isPlaying) {
                                const slen = sourceBuffer.current[stream_channel].buffered.length
                                if (slen > 0) {
                                    video.currentTime = sourceBuffer.current[stream_channel].buffered.start(slen - 1)
                                }
                            }
                        }
                    };

                    sourceBuffer.current[stream_channel].onerror = async (event) => {
                        console.error('SourceBuffer error: ', event);
                    };
                };
            }
            resolve(true)
        })
    }

    function remove_mediasource(stream_channel) {
        return new Promise((resolve, reject) => {
            if (mediaSource.current[stream_channel] !== null) {
                mediaSource.current[stream_channel].onsourceopen = null
                mediaSource.current[stream_channel] = null
                console.log('Remove mediaSource ')
            }
            if (sourceBuffer.current[stream_channel] !== null) {
                sourceBuffer.current[stream_channel].onupdateend = null
                sourceBuffer.current[stream_channel].onerror = null
                sourceBuffer.current[stream_channel] = null
                console.log('Remove sourceBuffer ')
            }
            resolve(true);
        });
    }

    async function select_camera(camera_id, camara_name, status) {
        if (channel_selected >= 0 && channel_selected < 9) {
            const idx = channelRef.current.findIndex((element) => element === camera_id)
            if (idx < 0) {
                setmodal_load({ enable: true, message: camara_name + " Start Streaming......." })
                await sleep(100)
                packageRef.current[channel_selected] = 0
                queueRef.current[channel_selected] = []
                var res_lock = await Lock_WebSocket(channel_selected)
                if (res_lock === true) {
                    await enable_mediasource(channel_selected)
                    await sleep(200)
                    await UnLock_WebSocket(channel_selected)
                    channelRef.current[channel_selected] = camera_id
                    var res_api = true
                    if (temp_api_state.current !== 2) {
                        res_api = await api_socket_connect(channelRef.current.join("-"))
                    } else {
                        res_api = await api_select_channel(channelRef.current.join("#"))
                    }
                    if (!res_api) {
                        channelRef.current[channel_selected] = ""
                    }
                } else {
                    await UnLock_WebSocket(channel_selected)
                }
                setmodal_load({ enable: false, message: "" })
            } else {
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: "Can not duplicate camera streaming !",
                    enable: true
                })
            }
        } else {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Error',
                message: "Please select live channel on right panel !",
                enable: true
            })
        }
    }

    async function remove_camera(camera_id, camara_name) {
        const idx = channelRef.current.findIndex((element) => element === camera_id)
        if (idx > -1) {
            setmodal_load({ enable: true, message: camara_name + " Stop Streaming......." })
            await sleep(200)
            var res_lock = await Lock_WebSocket(idx)
            if (res_lock === true) {
                var res_free = await Wait_SourceFree(idx)
                if (res_free === true) {
                    var clone = JSON.parse(JSON.stringify(channelRef.current))
                    clone[idx] = ""
                    var res_api = true
                    if (temp_api_state.current !== 2) {
                        res_api = await api_socket_connect(clone.join("-"))
                    } else {
                        res_api = await api_select_channel(clone.join("#"))
                    }
                    if (res_api === true) {
                        channelRef.current[idx] = ""
                        sourceBuffer.current[idx].onupdateend = null
                        sourceBuffer.current[idx].onerror = null
                        mediaSource.current[idx].onsourceopen = null
                        packageRef.current[idx] = 0
                        queueRef.current[idx] = []
                        sourceBuffer.current[idx] = null
                        const video = videoRef.current[idx];
                        video.src = URL.createObjectURL(mediaSource.current[idx])
                    }
                }
            }
            await UnLock_WebSocket(idx)
            setmodal_load({ enable: false, message: "" })
        } else {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Error',
                message: "Can not remove camera stream !",
                enable: true
            })
        }
    }

    function remove_btn(camera_id) {
        const idx = channelRef.current.findIndex((element) => element === camera_id)
        if (idx > -1) {
            return ""
        }
        return "d-none"
    }

    function select_channel(stream_channel) {
        setChannel_Selected(stream_channel)
    }

    // function open_hikvision() {
    //     if (props.data_systemconfig !== null && props.data_systemconfig !== undefined) {
    //         if (props.data_systemconfig.camera !== undefined) {
    //             if (props.data_systemconfig.camera.nvr_ip !== undefined) {
    //                 window.open("http://" + props.data_systemconfig.camera.nvr_ip, "_blank")
    //             }
    //         }
    //     }
    // }

    function fullscreen(stream_channel) {
        var el = document.getElementById("video" + stream_channel);
        if (el.requestFullscreen) {
            el.requestFullscreen();
        } else if (el.msRequestFullscreen) {
            el.msRequestFullscreen();
        } else if (el.mozRequestFullScreen) {
            el.mozRequestFullScreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        }
    }

    function api_select_channel(command) {
        return new Promise((resolve, reject) => {
            const formData = new FormData()
            formData.append('client_id', clientid.current)
            formData.append('command', command)
            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/cctv/selectchannel", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    resolve(true);
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                    resolve(true);
                });
        });
    }

    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function nevigate_hover(ch) {

    }

    function nevigate_leave(ch) {

    }

    function Lock_WebSocket(stream_channel) {
        block_ws_req.current[stream_channel] = true
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(false);
            }, 5000);
            if (block_ws_state.current[stream_channel] === false) {
                resolve(true);
            }
        });
    }

    async function UnLock_WebSocket(stream_channel) {
        block_ws_req.current[stream_channel] = false
    }

    async function Wait_SourceFree(stream_channel) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(false);
            }, 5000);
            if (!sourceBuffer.current[stream_channel].updating) {
                resolve(true);
            }
        });
    }

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"CCTV SYSTEM"}
                submenu_root={"CCTV Live View"}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <div id="page-content">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="row mb-0">
                                    <div className="col-xl-12">
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <h4 className="mb-1"><i className="mdi mdi-cctv color-orange"></i> CCTV Live View</h4>
                                                <p className="mb-1">Observe solar system with our CCTV device</p>
                                            </div>
                                            <div>
                                                {BackCenter()}
                                            </div>
                                        </div>
                                        <hr className="new-section-xs mb-0" />
                                    </div>
                                </div>

                                {/* <div className='row'>
                                    <div className='col-12 gap-3'>
                                        <div className="d-flex mt-2 gap-3">
                                            <button className='btn btn-sm btn-danger' onClick={() => open_hikvision()}><i className="far fa-window-restore me-1"></i> Open HikVision WebApp</button>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="d-flex mt-3 gap-3">
                                    <div className="cam-selecter">
                                        <h6 className='cam-header'>Camera Selector</h6>
                                        {
                                            cam_list.map((cam, index) => (
                                                <div className={'cam-item ' + (cam.status === true ? "online" : "")} key={index} onMouseOver={() => { nevigate_hover(cam.id) }} onMouseLeave={() => { nevigate_leave(cam.id) }}><div className='cam-item-left' onClick={() => { select_camera(cam.id, cam.name, cam.status) }}><i className="mdi mdi-cctv me-2"></i> {cam.name}</div> <div className={'cam-item-right ' + remove_btn(cam.id, cam.name)} onClick={() => { remove_camera(cam.id, cam.name) }}><i className="fas fa-window-close text-danger"></i></div></div>
                                            ))
                                        }
                                    </div>
                                    <div className="d-block" style={{ maxWidth: "1100px" }}>
                                        <div className="d-flex gap-3">
                                            <h6 className='cam-header'>Camera Live Streaming View</h6>
                                            <h6 className={'cam-header status ' + (api_state_display === true ? "alarming" : "d-none")}>Camera Stream API : Lose</h6>
                                        </div>
                                        <div className="d-flex justify-content-start flex-wrap">
                                            <div className={"video-container " + (channel_selected === 0 ? "channel-selected" : "")} onClick={() => { select_channel(0) }} onDoubleClick={() => { fullscreen("0") }}>
                                                <video id="video0" className="video" ref={el => videoRef.current[0] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 1 ? "channel-selected" : "")} onClick={() => { select_channel(1) }} onDoubleClick={() => { fullscreen("1") }}>
                                                <video id="video1" className="video" ref={el => videoRef.current[1] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 2 ? "channel-selected" : "")} onClick={() => { select_channel(2) }} onDoubleClick={() => { fullscreen("2") }}>
                                                <video id="video2" className="video" ref={el => videoRef.current[2] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 3 ? "channel-selected" : "")} onClick={() => { select_channel(3) }} onDoubleClick={() => { fullscreen("3") }}>
                                                <video id="video3" className="video" ref={el => videoRef.current[3] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 4 ? "channel-selected" : "")} onClick={() => { select_channel(4) }} onDoubleClick={() => { fullscreen("4") }}>
                                                <video id="video4" className="video" ref={el => videoRef.current[4] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 5 ? "channel-selected" : "")} onClick={() => { select_channel(5) }} onDoubleClick={() => { fullscreen("5") }}>
                                                <video id="video5" className="video" ref={el => videoRef.current[5] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 6 ? "channel-selected" : "")} onClick={() => { select_channel(6) }} onDoubleClick={() => { fullscreen("6") }}>
                                                <video id="video6" className="video" ref={el => videoRef.current[6] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 7 ? "channel-selected" : "")} onClick={() => { select_channel(7) }} onDoubleClick={() => { fullscreen("7") }}>
                                                <video id="video7" className="video" ref={el => videoRef.current[7] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                            <div className={"video-container " + (channel_selected === 8 ? "channel-selected" : "")} onClick={() => { select_channel(8) }} onDoubleClick={() => { fullscreen("8") }}>
                                                <video id="video8" className="video" ref={el => videoRef.current[8] = el} autoPlay muted  >
                                                </video>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ScrollToTopButton />
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </section>
    )
}
export default CCTVStreaming